import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import "./discount.css"
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import logo_pop from "../../../assets/images/logo-pop.png"
import AcceptInput from '../../chooseUserBuy/accept/accept';



 
const Discount = (props) => {
    const [isChoosen, setIsChoosen] = useState(false)
    function ChooseDiscont(e,name, discount){
        setIsChoosen(!isChoosen)
    
        props.choose(e,name, discount)
    }
    

    
  

    return <> 
    <AcceptInput unClickElement={props.unClickElement} discountAction={(e)=>{ChooseDiscont(e,props.discount)}} discount={props.discount} label={props.tittle}></AcceptInput>
    
    </>;
    }

export default Discount;
